import {ref} from 'vue';
import {Ref} from '@vue/reactivity';
import {configuration} from "@/composables/ConfigurationComposition";

class FilterComposition {
    private _distance: Ref<number> = ref(configuration.filterDistances[0]?.key);
    private _region: Ref<string> = ref(configuration.filterRegions[0]?.key);
    private _type: Ref<string> = ref(configuration.filterTypes[0]?.key);

    public readonly distanceRef = this._distance;
    public readonly regionRef = this._region;
    public readonly typeRef = this._type;

    get distance(): number {
        return this._distance.value;
    }

    set distance(value: number) {
        this._distance.value = value;
    }

    get type(): string {
        return this._type.value;
    }

    set type(value: string) {
        this._type.value = value;
    }

    get region(): string {
        return this._region.value;
    }

    set region(value: string) {
        this._region.value = value;
    }

    reset() {
        this.distance = configuration.filterDistances[0]?.key;
        this.region = configuration.filterRegions[0]?.key;
        this.type = configuration.filterTypes[0]?.key;
    }
}

export const useFilterComposition = new FilterComposition();
